<template>
  <div class="tag-container" v-if="config.filters && config.filters.length > 0">
    <span class="tag-filter" v-tooltip="{ content: filtersLabel, placement: 'top-left' }"
      ><i class="fas fa-filter"></i>
    </span>
  </div>
</template>
<script>
import { utilsMixin, sitesMixin } from '../../utils/mixins'

export default {
  name: 'TagFilters',
  mixins: [utilsMixin, sitesMixin],
  data() {
    return {
      filters: [],
      filtersLabel: '',
    }
  },
  props: {
    config: {
      type: Object,
      required: true,
    },
  },
  watch: {
    config: {
      handler() {
        this.onConfigChange()
      },
      immediate: true,
    },
  },
  mounted() {
    this.onConfigChange()
  },
  methods: {
    onConfigChange: function() {
      this.formatFilters()
    },
    formatFilters() {
      this.filters = []
      this.filtersLabel = ''
      this.config.filters.forEach(configFilter => {
        this.filtersLabel += this.getTagLabel(configFilter)
      })
    },
    getTagLabel(filter) {
      let htmlFilters = ''
      filter.values.forEach(value => {
        switch (filter.type) {
          case 'site':
          case 'site_location':
            htmlFilters += this.getLocalizedSiteName(value)
            break
          case 'site_id':
          case 'language':
          case 'product':
          case 'warning_type':
          case 'status':
            htmlFilters += this.$t(`${filter.type}.${value}`)
            break
          case 'histopad_rating':
          case 'visit_rating':
            htmlFilters +=
              value > 1 ? `${value} ${this.$t('stars')}` : `${value} ${this.$t('star')}`
            break
          case 'collected_treasure_count':
            htmlFilters +=
              value > 1 ? `${value} ${this.$t('treasures')}` : `${value} ${this.$t('treasure')}`
            break
          default:
            htmlFilters += value
            break
        }

        htmlFilters += '<br>'
      })

      return htmlFilters
    },
  },
}
</script>
<style scoped>
.tag-container {
  position: absolute;
  top: 0.4em;
  left: 1.6em;
}

.tag-container span {
  font-size: 0.8em;
}

.tag-container .badge {
  margin-right: 0.4em;
}

.badge-site_id {
  color: #fff;
  background-color: #1e112e;
}

.badge-language {
  color: #fff;
  background-color: #b4415b;
}

.badge-histopad_rating {
  color: #fff;
  background-color: #a88161;
}

.badge-visit_rating {
  color: #fff;
  background-color: #5e6152;
}

.badge-collected_treasure_count {
  color: #fff;
  background-color: #4e4e67;
}

.badge-product {
  color: #fff;
  background-color: #735362;
}

.badge-version {
  color: #fff;
  background-color: #534736;
}

.badge-player_version {
  color: #fff;
  background-color: #c55f4a;
}

.badge-operating_system {
  color: #fff;
  background-color: #6b8080;
}
</style>
